// extracted by mini-css-extract-plugin
module.exports = {"root":"B_bJ"};